import { useState } from 'react';

import type {
  CurrentUser,
  LegalHold,
  LegalHoldScope,
  Membership,
  RetentionDraft,
  SupportCase,
  Tenant,
  TenantRetentionPolicy,
} from '../domain-types';

export function useTenant() {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [selectedTenantId, setSelectedTenantId] = useState('');
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const [members, setMembers] = useState<Membership[]>([]);
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteRole, setInviteRole] = useState('standard_user');
  const [notificationEmail, setNotificationEmail] = useState('');
  const [offboardingReason, setOffboardingReason] = useState('');
  const [supportCases, setSupportCases] = useState<SupportCase[]>([]);
  const [supportSubject, setSupportSubject] = useState('');
  const [supportDescription, setSupportDescription] = useState('');
  const [supportPriority, setSupportPriority] = useState<'normal' | 'high'>('normal');
  const [supportResponses, setSupportResponses] = useState<Record<string, string>>({});
  const [supportBusy, setSupportBusy] = useState(false);
  const [retentionPolicy, setRetentionPolicy] = useState<TenantRetentionPolicy | null>(null);
  const [legalHolds, setLegalHolds] = useState<LegalHold[]>([]);
  const [retentionDraft, setRetentionDraft] = useState<RetentionDraft>({
    qualityRecordsDays: 2_555,
    surveyResponsesDays: 730,
    filesDays: 2_555,
    supportCasesDays: 730,
    auditEventsDays: 2_555,
  });
  const [legalHoldScope, setLegalHoldScope] = useState<LegalHoldScope>('all_tenant_data');
  const [legalHoldReason, setLegalHoldReason] = useState('');
  const [legalHoldReference, setLegalHoldReference] = useState('');
  const [legalHoldReleaseReasons, setLegalHoldReleaseReasons] = useState<Record<string, string>>(
    {},
  );
  const [retentionBusy, setRetentionBusy] = useState(false);
  return {
    currentUser,
    setCurrentUser,
    selectedTenantId,
    setSelectedTenantId,
    tenant,
    setTenant,
    members,
    setMembers,
    inviteEmail,
    setInviteEmail,
    inviteRole,
    setInviteRole,
    notificationEmail,
    setNotificationEmail,
    offboardingReason,
    setOffboardingReason,
    supportCases,
    setSupportCases,
    supportSubject,
    setSupportSubject,
    supportDescription,
    setSupportDescription,
    supportPriority,
    setSupportPriority,
    supportResponses,
    setSupportResponses,
    supportBusy,
    setSupportBusy,
    retentionPolicy,
    setRetentionPolicy,
    legalHolds,
    setLegalHolds,
    retentionDraft,
    setRetentionDraft,
    legalHoldScope,
    setLegalHoldScope,
    legalHoldReason,
    setLegalHoldReason,
    legalHoldReference,
    setLegalHoldReference,
    legalHoldReleaseReasons,
    setLegalHoldReleaseReasons,
    retentionBusy,
    setRetentionBusy,
  };
}
